import Users from "entities/Users";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BiPlus } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { AccountFilters } from "shared/components/AccountStatus";
import Card from "shared/components/Card";
import Empty from "shared/components/Empty";
import Header from "shared/components/Header";
import useAccountLock from "shared/hooks/useAccountLock";
import { NAME_SPACES } from "shared/locales/constants";
import { SCREENS, USER_TYPES } from "utils/constants";
import View from "./View";

const List = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.COLLABORATOR);
  const LIST = t("LIST", { returnObjects: true });

  const onDetail = (id) =>
    navigate(`${SCREENS.PRIVATE.BROKER.COLLABORATORS.DETAIL.path}/${id}`);

  const onDelete = (id) =>
    navigate(`${SCREENS.PRIVATE.BROKER.COLLABORATORS.DELETE.path}/${id}`);

  const [pagination, setPagination] = useState({});
  const [filter] = useState({
    where: {
      OR: [
        { meta: { type: USER_TYPES.BROKER_EMPLOYEE.type } },
        { meta: { type: USER_TYPES.BROKER_REPRESENTATIVE.type } },
        { meta: { type: USER_TYPES.INSURANCE_REPRESENTATIVE.type } },
        { meta: { type: USER_TYPES.INTERNAL_ADVISOR.type } },
      ],
    },
  });

  const [lastname, setLastname] = useState("");
  const [firstname, setFirstname] = useState("");
  const { lockStates, onUnlock, status, setStatus, statusIds, statusOptions } =
    useAccountLock(filter.where);

  const resetPage = () => setPagination((prev) => ({ ...prev, skip: 0 }));

  const like = {
    ...(lastname && { lastname: `%${lastname}%` }),
    ...(firstname && { firstname: `%${firstname}%` }),
  };

  const addCollaborator = () =>
    navigate(SCREENS.PRIVATE.BROKER.COLLABORATORS.CREATE.path);

  const hasFilters = Boolean(lastname || firstname || status);

  const noData = () =>
    hasFilters ? (
      <Empty type="normal" message={LIST.NO_MATCH} />
    ) : (
      <Empty
        type="normal"
        label={LIST.HEADER.CREATE}
        message={LIST.EMPTY_MESSAGE}
        onClick={addCollaborator}
      />
    );

  return (
    <>
      <Header
        key={"header"}
        title={LIST.HEADER.TITLE}
        actions={[
          {
            icon: <BiPlus size={20} />,
            text: LIST.HEADER.CREATE,
            onClick: addCollaborator,
          },
        ]}
      />
      <Card type={"simple"}>
        <AccountFilters
          onLastnameChange={(value) => {
            resetPage();
            setLastname(value);
          }}
          onFirstnameChange={(value) => {
            resetPage();
            setFirstname(value);
          }}
          status={status}
          onStatusChange={(value) => {
            resetPage();
            setStatus(value);
          }}
          statusOptions={statusOptions}
          showStatus={Boolean(lockStates)}
        />

        <Users
          View={View}
          onDetail={onDetail}
          onDelete={onDelete}
          onUnlock={onUnlock}
          lockStates={lockStates}
          addCollaborator={addCollaborator}
          filter={{
            ...filter,
            like,
            ...(statusIds && { isIn: { id: statusIds } }),
            ...pagination,
          }}
          setValues={setPagination}
          skip={pagination.skip || 0}
          NoData={noData}
        />
      </Card>
    </>
  );
};

export default List;
